//@ts-nocheck
import { LitElement, css, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import "@banno/jha-wc/src/icons/jha-icon-delete";
import "@banno/jha-wc/src/tables/jha-table/jha-table";
import "@banno/jha-wc/src/tables/jha-table-cell/jha-table-cell";
import "@banno/jha-wc/src/tables/jha-table-header/jha-table-header";
import "@banno/jha-wc/src/tables/jha-table-row/jha-table-row";
import "@banno/jha-wc/src/forms/jha-form-checkbox/jha-form-checkbox";
import "@banno/jha-wc/src/icons/jha-icon-information";
import "@banno/jha-wc/src/icons/jha-icon-edit";
import "@banno/jha-wc/src/icons/jha-icon-show";
import "@banno/jha-wc/src/buttons/jha-button/jha-button";
import { AddWorkflowStepPopup } from "./AddWorkflowStepPopup";
import DialogUtil from "@banno/jha-wc/src/js/utils/dialog-util";
import { openJhftDialog } from "../../Components/JhftJhaDialog";
import { EditWorkflowStepPopup } from "./EditWorkflowStepPopup";
import Cookies from "js-cookie";
import { decryptValue, stringComparison, getEnvApiUrl } from "../../utils/app-utils";
import { getRequest } from "../../utils/jha-fetch";
import { Apis } from "../../utils/api-constants";
import { showToast } from "@banno/jha-wc/src/js/utils/toast-util.js";
import { GlobalVariables } from "../../utils/constants";
import { getStepFunctionDisplayLabel } from "../../utils/step-function-display";
import { stepToPopupFormat } from "../../utils/api-normalizer";

@customElement("workflow-steps-view")
export class WorkflowStepsView extends LitElement {
  static readonly styles = css`
    :host {
      display: block;
      padding: 20px;
    }
    #workflowDiv {
      display: flex;
      flex-direction: column;
    }
    jha-table {
      flex: 1;
      width: 100%;
      box-sizing: border-box;
      border-collapse: collapse;
    }
    jha-table-header {
      font-weight: 600;
      padding: 12px;
      text-align: left;
      white-space: nowrap;
      background: var(--jh-color-container-primary-enabled, rgb(244, 244, 244));
      border-top: 1px solid var(--jh-color-divider-primary);
    }
    jha-table-cell {
      padding: 12px;
      vertical-align: middle;
      border-left: 1px solid var(--jha-advanced-table-cell-border);
      font-size: 15px;
      line-height: 1.4;
    }
    jha-table-row {
      border-bottom: 1px solid;
    }
    h2 {
      margin-top: 0;
      margin-bottom: 20px;
      font-size: 24px;
      font-weight: 600;
    }
    .info-text {
      color: var(--jha-text-light);
      font-size: 14px;
      margin-top: 0;
      margin-bottom: 16px;
    }
    .no-steps-message {
      padding: 32px;
      text-align: center;
      border: 1px solid;
      border-top: none;
    }
    @media (prefers-color-scheme: dark) {
      h2 {
        color: #a3d4ff;
      }
      .no-steps-message {
        color: #a0a0a0;
        border-color: #3a3a3a;
      }
      jha-table {
        border: 1px solid #3a3a3a;
      }
      jha-table-row {
        border-bottom-color: #3a3a3a;
      }
    }
    @media (prefers-color-scheme: light) {
      h2 {
        color: #06185f;
      }
      .no-steps-message {
        color: #666666;
        border-color: #e0e0e0;
      }
      jha-table-row {
        border-bottom-color: #e0e0e0;
      }
    }
    .action-icons {
      display: flex;
      gap: 8px;
      align-items: center;
      justify-content: center;
      width: 100%;
    }
    .action-icon {
      cursor: pointer;
      width: 20px;
      height: 20px;
      transition: opacity 0.2s;
    }
    .action-icon:hover {
      opacity: 0.7;
    }
    jha-icon-edit,
    jha-icon-show {
      color: var(--jha-color-primary, #0066cc);
    }
    jha-icon-delete {
      color: var(--jha-color-danger, #dc3545);
    }
    #btnDiv {
      display: flex;
      margin-top: 20px;
      justify-content: end;
    }
    jha-icon-warning-filled{
      fill: var(--jha-color-warning);      
     padding-left: 5px;
    }
    .align-span-text{
     display: flex;
     align-items: center;
    }
    .delete-files-section {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .delete-files-section p {
      margin: 0;
      font-size: 14px;
    }
    .info-tooltip {
      position: relative;
    }
    #filePatternTooltip {
    position: absolute;
    border-radius:4px;
    padding:8px;
    width: 500px;
    background:black;
    color:white;
    box-sizing:border-box;
    z-index:1061;
    display: none; 
  }
    .iconInfo:hover + #filePatternTooltip {
    display: block;
  }
  `;
  @property()
  toUpdate: "update";
  @property()
  stepIndex = 0;
  @property({ type: Array })
  workflowStepsData = [];
  @property()
  formData = {
    workflowName: "",
    WorkflowId: "",
    TransferType: "",
    BusinessUnitParticipant: stringComparison(decryptValue(Cookies.get("userType")), "BusinessAdmin") ? this.loggedUserBu?.toLowerCase() : "",
    sourceLocationPath: "",
    TriggerFilePattern: [] = [],
    DataFilePattern: [] = [],
    valid: false,
    isEdit: false,
    DeleteFiles: true
  };
  @property({ type: Object })
  workflowStepItem = {};
  @property({ type: Boolean })
  isReadOnlyUser = /readonly/i.test(decryptValue(Cookies.get("userRole")))

  /**
   * [ACME-1422] Cached Business Unit catalog used to resolve a friendly display
   * name from `formData.BusinessUnitParticipant` (the selected BU value/id) when
   * launching `AddWorkflowStepPopup`. The popup uses this to render the SMB
   * bucket preview as `{env}-smb-{slug}` matching what the API persists.
   */
  @property({ type: Array })
  businessUnits: Array<{ value: string; name: string }> = [];

  async connectedCallback() {
    super.connectedCallback();
    try {
      const response = await getRequest(getEnvApiUrl(Apis.GET_ALL_BUSINESSUNITVALUES));
      this.businessUnits = (response?.businessUnitValues ?? []).map((bu) => ({ value: bu.value, name: bu.name }));
    } catch (e) {
      // Non-fatal: popup falls back to buName when display name is unavailable.
      this.businessUnits = [];
    }
  }

  private resolveBuDisplayName(): string {
    const selected = this.formData?.BusinessUnitParticipant;
    if (!selected) return "";
    const match = this.businessUnits.find((bu) => bu.value?.toLowerCase() === selected.toLowerCase());
    return match ? match.name : "";
  }

  firstUpdated() {
    this.dispatch();
  }

  refreshTable(data) {
    this.workflowStepsData.push(data);
  }
  async onAddWorkflowStepsClick() {
    try {
      let lastDelete = false;
      if (this.workflowStepsData.length > 0) {
        this.workflowStepsData.forEach((element) => {
          if (
            ((stringComparison(element.deleteSourceFile, "true") ||
              element.deleteSourceFile == true)) && (!stringComparison(element.functionName, "UnprocessedFileArchive")) && (!stringComparison(element.functionName, "FileDelete"))
          ) {
            lastDelete = true;
          }
        });
      }
      const dlg = new AddWorkflowStepPopup(
        this.formData.TransferType,
        false,
        lastDelete,
        this.formData.TransferType,
        this.formData.isClone,
        this.formData.WorkflowName,
        this.formData.BusinessUnitParticipant,
        false
      );
      dlg.workflowSourceLocationPath = this.formData.sourceLocationPath ?? '';
      dlg.workflowId = this.formData.WorkflowId ?? '';
      // [ACME-1422] Bind friendly BU display name for the S3 SMB bucket preview.
      dlg.buDisplayName = this.resolveBuDisplayName();
      const data = await DialogUtil.awaitDialog({
        dialog: dlg,
      });
      if (!data) return;
      const snapshot = JSON.parse(JSON.stringify(data));
      this.stepIndex = this.workflowStepsData.length + 1;
      snapshot.stepIndex = this.stepIndex;
      this.workflowStepsData = [...this.workflowStepsData, snapshot];
      this.dispatch();
    } catch (e) { }
  }

  checkDeleteFlag(e: Event) {
    this.formData.DeleteFiles = e.detail.checked;
    this.dispatch();
  }
  async onEditWorkflowStepsClick(item, isViewOnly = false) {
    let saveStepIndex;
    saveStepIndex = item.stepIndex;
    try {
      this.workflowStepItem = item;
      let lastDelete = false;
      let stepIndex;
      if (this.workflowStepsData.length > 0) {
        this.workflowStepsData.forEach((element) => {
          if ((stringComparison(element.deleteSourceFile, "true") ||
            element.deleteSourceFile == true) && (!stringComparison(element.functionName, "UnprocessedFileArchive")) && (!stringComparison(element.functionName, "FileDelete"))) {
            stepIndex = element.stepIndex;
          }
        });
        if ((stringComparison(this.workflowStepItem.functionName, "UnprocessedFileArchive")) || (stringComparison(this.workflowStepItem.functionName, "FileDelete"))) {
          lastDelete = false;
        }
        else {
          if (this.workflowStepItem.stepIndex != stepIndex && stepIndex != undefined) {
            lastDelete = true;
          }
        }
      }
      const stepForPopup = stepToPopupFormat(item, this.formData.TransferType);
      const dlgEdit = new AddWorkflowStepPopup(stepForPopup, true, lastDelete, this.formData.TransferType, this.formData.isClone, this.formData.WorkflowName, this.formData.BusinessUnitParticipant, isViewOnly);
      dlgEdit.workflowSourceLocationPath = this.formData.sourceLocationPath ?? '';
      dlgEdit.workflowId = this.formData.WorkflowId ?? '';
      // [ACME-1422] Bind friendly BU display name for the S3 SMB bucket preview.
      dlgEdit.buDisplayName = this.resolveBuDisplayName();
      const data = await DialogUtil.awaitDialog({
        dialog: dlgEdit,
      });
      if (!data) return;
      if (isViewOnly) return;
      let deleteIndex = this.workflowStepsData.indexOf(item);
      if (deleteIndex < 0) {
        deleteIndex = this.workflowStepsData.findIndex((s) => s.stepIndex === saveStepIndex);
      }
      if (deleteIndex < 0) {
        showToast({
          message: "Unable to update the workflow step. Please try again.",
          role: "danger",
          duration: GlobalVariables.TOAST_TIMEOUT,
        });
        return;
      }
      const snapshot = JSON.parse(JSON.stringify(data));
      snapshot.stepIndex = saveStepIndex;
      const updatedSteps = [...this.workflowStepsData];
      updatedSteps.splice(deleteIndex, 1, snapshot);
      this.workflowStepsData = updatedSteps;
      this.dispatch();
    } catch (e) { }
  }
  async onDeleteStepClick(item) {
    const result = await openJhftDialog({
      variant: "danger",
      title: "Delete Workflow Step",
      message: "Are you sure you want to delete this workflow step?",
      cancelLabel: "Cancel",
      confirmLabel: "Delete",
    });
    if (result !== "confirm") return;
    if (!this.onDeleteWorkflowStepsClick(item)) {
      showToast({
        message: "Unable to delete the workflow step. Please try again.",
        role: "danger",
        duration: GlobalVariables.TOAST_TIMEOUT,
      });
      return;
    }
    showToast({
      message: "Workflow Step is deleted.",
      role: "success",
      duration: GlobalVariables.TOAST_TIMEOUT,
    });
  }
  onDeleteWorkflowStepsClick(item): boolean {
    let deleteIndex = this.workflowStepsData.indexOf(item);
    if (deleteIndex < 0) {
      deleteIndex = this.workflowStepsData.findIndex((s) => s.stepIndex === item?.stepIndex);
    }
    if (deleteIndex < 0) return false;
    const updatedSteps = [...this.workflowStepsData];
    updatedSteps.splice(deleteIndex, 1);
    updatedSteps.forEach((element: any, index: number) => {
      element.stepIndex = index + 1;
    });
    this.workflowStepsData = updatedSteps;
    this.dispatch();
    return true;
  }
  dispatch() {
    this.dispatchEvent(
      new CustomEvent("onStepsChange", {
        detail: {
          workflowStepsData: [...this.workflowStepsData],
          deleteFiles: this.formData.DeleteFiles ?? true
        },
        bubbles: true,
        composed: true
      })
    );
  }
  renderStepsHeader() {
    return html`
      <jha-table-header style="width: 60px;">NO.</jha-table-header>
      <jha-table-header style="min-width: 200px;">STEP NAME</jha-table-header>
      <jha-table-header style="min-width: 200px;">STEP FUNCTION</jha-table-header>
      <jha-table-header style="width: 120px; text-align: center;">ACTIONS</jha-table-header>
    `;
  }

  renderStepActions(item) {
    return html`
                <jha-table-cell>
        <div class="action-icons">
          ${this.isReadOnlyUser
        ? html`
          <jha-tooltip left text="View Workflow Step">
            <jha-icon-show class="action-icon" data-auto-id="viewWorkflowStepBtn" @click=${() => this.onEditWorkflowStepsClick(item, true)}></jha-icon-show>
          </jha-tooltip>
        `
        : html`
          <jha-tooltip left text="Edit Workflow Step">
            <jha-icon-edit class="action-icon" data-auto-id="editWorkflowStepBtn" @click=${() => this.onEditWorkflowStepsClick(item)}></jha-icon-edit>
          </jha-tooltip>
          <jha-tooltip left text="Delete Workflow Step">
            <jha-icon-delete class="action-icon" data-auto-id="deleteWorkflowStepBtn" @click=${() => this.onDeleteStepClick(item)}></jha-icon-delete>
          </jha-tooltip>
        `}
        </div>
      </jha-table-cell>
    `;
  }

  render() {
    return this.formData.TransferType == "push" ?
      html`           
      <div id="workflowDiv">
       <h2>Workflow Steps</h2>
       <p class="info-text">Configure the steps that will be executed when this workflow runs. Steps are optional.</p>
       <div class="delete-files-section">
        <jha-form-checkbox
          data-id="deleteSourceFile"
          data-auto-id="deleteSourceFileCheckbox"
          .checked=${this.formData.DeleteFiles ?? true}
          ?disabled=${this.isReadOnlyUser}
          @change=${this.checkDeleteFlag}
        >
          <p>Delete files from Source Location Path after workflow execution?</p>
        </jha-form-checkbox>
        <div class="info-tooltip">
          <jha-icon-information class="iconInfo" data-auto-id="deleteSourceFileInfo"></jha-icon-information>
          <span id="filePatternTooltip">
            Files in the Source Location Path are deleted after workflow execution only if the workflow contains at least one step
          </span>
        </div>
        </div>
        <jha-table>
          <jha-table-row>
            ${this.renderStepsHeader()}
          </jha-table-row>
          ${this.workflowStepsData?.map(
        (item) => html`
              <jha-table-row>
                <jha-table-cell> <span class="align-span-text">${item.stepIndex} ${item.isValidStep == false ? html`<jha-icon-warning-filled icon ></jha-icon-warning-filled>` : ''}</span></jha-table-cell>
                <jha-table-cell>${item.stepName}</jha-table-cell>
                <jha-table-cell>${getStepFunctionDisplayLabel(item.functionName)}</jha-table-cell>
                ${this.renderStepActions(item)}
              </jha-table-row>
            `
      )}
        </jha-table>
        ${this.workflowStepsData?.length ? '' : html`<div class="no-steps-message"><h3>No Steps Found</h3></div>`}
        <div id="btnDiv">
        <jha-tooltip left text="Click to Add Workflow Step">
          <jha-button data-auto-id="addWorkflowStepBtn" sync primary type="button" @click=${this.onAddWorkflowStepsClick} ?disabled=${this.isReadOnlyUser}
            ><jha-icon-plus slot="icon-left"></jha-icon-plus>Add Workflow Step
            </jha-button
          >
        </jha-tooltip>
        </div>
      </div>
    ` :
      html`
      <div id="workflowDiv">
        <h2>Workflow Steps</h2>
        <p class="info-text">Configure the steps that will be executed when this workflow runs. Steps are optional.</p>
        <jha-table>
          <jha-table-row>
            ${this.renderStepsHeader()}
          </jha-table-row>
          ${this.workflowStepsData?.map(
        (item) => html`
              <jha-table-row>
                <jha-table-cell> <span class="align-span-text">${item.stepIndex} ${item.isValidStep == false ? html`<jha-icon-warning-filled icon ></jha-icon-warning-filled>` : ''}</span></jha-table-cell>
                <jha-table-cell>${item.stepName}</jha-table-cell>
                <jha-table-cell>${getStepFunctionDisplayLabel(item.functionName)}</jha-table-cell>
                ${this.renderStepActions(item)}
              </jha-table-row>
            `
      )}
        </jha-table>
        ${this.workflowStepsData?.length ? '' : html`<div class="no-steps-message"><h3>No Steps Found</h3></div>`}
        <div id="btnDiv">
        <jha-tooltip left text="Click to Add Workflow Step">
          <jha-button data-auto-id="addWorkflowStepBtn" sync primary type="button" @click=${this.onAddWorkflowStepsClick} ?disabled=${this.isReadOnlyUser}
            ><jha-icon-plus slot="icon-left"></jha-icon-plus>Add Workflow Step
            </jha-button
          >
        </jha-tooltip>
        </div>
      </div>
    ` ;
  }
}
declare global {
  interface HTMLElementTagNameMap {
    "workflow-steps-view": WorkflowStepsView;
  }
}

